import imagePlaceholder from "./placeholder-vert.jpg";
import BookCover from "./book-cover.png";
import BookNetflix from "./book-netflix.png";
import BookDarkSide from "./book-dark-side.png";
import NotFoundImage1 from "./404-1.png";
import NotFoundImage2 from "./404-2.png";
import AboutImage from "./about.png";
import BookClub from "./book-club.png";
import Banner1 from "./banner-1.jpg";
import Banner2 from "./banner-2.jpg";
import Banner3 from "./banner-3.jpg";

export const images = {
  imagePlaceholder,
  BookCover,
  BookNetflix,
  BookDarkSide,
  NotFoundImage1,
  NotFoundImage2,
  AboutImage,
  BookClub,
  Banner1,
  Banner2,
  Banner3,
};
